import { SxProps } from "@mui/material";

export const wrapperHeader: SxProps = {
  boxShadow: "0px 7px 16px -7px #00000040",
  background: "#1B191966",
  height: "85px",
  top: 0,
  zIndex: 10,
  right: "0",
  width: "100%",
  "&>div": {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    "& img": {
      position: "relative",
      top: "-15px",
    },
  },
  "@media (max-width: 900px)": {
    height: "60px",
    paddingTop: "13px",
    "& a img": {
      top: "-27px",
    },
  },
  "@media (max-width: 370px)": {
    "& a img": {
      width: "120px",
    },
  },
  "@media (max-width: 350px)": {
    "& a img": {
      width: "100px",
    },
  },
};

export const wrapperMenu: SxProps = {
  display: "flex",
  marginTop: "-16px",
  order: "2",
  "& .MuiPaper-root": {
    boxShadow: "unset",
    background: "transparent",
    position: "unset",
    "& a": {
      padding: "0 5px",
      "& button": {
        fontSize: "14px",
        "& svg": {
          width: "5px",
          height: "5px",
          marginRight: "5px",
        },
      },
    },
  },

  "@media (max-width: 900px)": {
    order: "3",
    "& button": {
      border: "1px solid #FF9800",
      borderRadius: "8px",
      width: "38px",
      height: "38px",
      color: "#FF9800",
      right: "-42px",
      top: "2px",
    },
  },
  "@media (max-width: 600px)": {
    "& button": {
      right: "-28px",
      top: "6px",
    },
  },
};

export const wrapperButton: SxProps = {
  order: "3",
  position: "relative",
  top: "-1px",
  "& .notif_item": {
    borderRadius: "8px",
    height: "38px",
    width: "38px",
    color: "#FF9800",
    border: "1px solid #FF9800",
    marginRight: "6px",
    "& svg": {
      marginRight: "0px",
    },
  },
  "& svg": {
    marginRight: "5px",
  },
  "@media (max-width: 900px)": {
    order: "2",
    position: "absolute",
    right: "67px",
    top: "12px",
  },
  "@media (max-width: 600px)": {
    right: "60px",
  },
  "@media (max-width: 460px)": {
    "& .notif_item": {
      display: "none",
    },
  },
};

export const wrapperWin: SxProps = {
  display: "flex",
  justifyContent: "flex-start !important",
  position: "relative",
  width: "100%",
  overflow: "hidden",
  padding: "0 18px",
  background: "rgba(12, 18, 40, 0.35)",
  border: "1px solid rgba(255,255,255,0.10)",
  backdropFilter: "blur(14px) saturate(140%)",
  WebkitBackdropFilter: "blur(14px) saturate(140%)",
  boxShadow:
    "0 10px 40px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.06)",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: "12px",
    right: "12px",
    height: "3px",
    borderRadius: "999px",
    background:
      "linear-gradient(90deg, transparent 0%, #ff8a00 20%, #ffd000 45%, #ff3d00 70%, transparent 100%)",
    boxShadow: "0 0 18px rgba(255,138,0,0.55), 0 0 36px rgba(255,61,0,0.25)",
  },
  "&::after": {
    content: '""',
    position: "absolute",
    inset: "-40%",
    pointerEvents: "none",
    background:
      "radial-gradient(circle at 30% 30%, rgba(255,208,0,0.14), rgba(255,208,0,0) 55%)",
    filter: "blur(10px)",
    animation: "neonDrift 6s ease-in-out infinite",
  },
  "&>span": { fontSize: "30px" },
  "& h5": {
    letterSpacing: "1px",
    fontWeight: "700",
    fontSize: "22.5px",
    "& span": {
      marginLeft: "8px",
      color: "#FF9800",
      fontWeight: "700",
    },
  },
  "& h6": {
    opacity: "0.7",
    fontSize: "16.5px",
  },
  "& a": {
    color: "inherit",
  },
  "& button": {
    marginTop: "10px",
    height: "30px !important",
    fontSize: "14px",
    fontWeight: "700",
  },
  "@media (max-width: 1200px)": {
    "& h6": {
      display: "none",
    },
  },
  "@media (max-width: 600px)": {
    "& h5": {
      paddingTop: "15px",
      paddingLeft: "10px",
      paddingRight: "10px",
      fontSize: "11.5px",
    },
  },
};
